import React from 'react';
import {
  SidebarWithHeader,
  PrestataireTable,
  CreateNewAdminModal,
} from '../components';
import { useAdminContext } from '../context/admin_context';
import { HStack, Button, VStack, Spinner, Heading } from '@chakra-ui/react';
import { MdOutlineRefresh } from 'react-icons/md';

function PrestatairesPage() {
  const {
    admins,
    admins_loading: loading,
    admins_error: error,
    fetchAdmins,
  } = useAdminContext();

  const handleRefresh = async () => {
    await fetchAdmins();
  };

  if (loading) {
    return (
      <SidebarWithHeader>
        <HStack mb={5}>
          <Button
            colorScheme='brown'
            variant='outline'
            leftIcon={<MdOutlineRefresh />}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        </HStack>
        <VStack alignItems='center' justifyContent='center'>
          <Spinner size='lg' color='brown.500' />
        </VStack>
      </SidebarWithHeader>
    );
  }

  if (error) {
    return (
      <SidebarWithHeader>
        <HStack mb={5}>
          <Button
            colorScheme='brown'
            variant='outline'
            leftIcon={<MdOutlineRefresh />}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        </HStack>
        <VStack alignItems='center' justifyContent='center'>
          <Heading color='red.500'>There was an error</Heading>
        </VStack>
      </SidebarWithHeader>
    );
  }

  // Filter the admins array to display only users with "prestataire" privilege
  const prestataireAdmins = admins.filter(admin => admin.privilege === 'client');

  return (
    <SidebarWithHeader>
      <HStack mb={5}>
        <CreateNewAdminModal />
        <Button
          colorScheme='brown'
          variant='outline'
          leftIcon={<MdOutlineRefresh />}
          onClick={handleRefresh}
        >
          Refresh
        </Button>
      </HStack>
      <PrestataireTable admins={prestataireAdmins} />
    </SidebarWithHeader>
  );
}

export default PrestatairesPage;